<section class="pins {{ scheme }}">
  @for (product of this.sortedProduct || []; track product) {
    <div (click)="display(product)" class="pin-container">
      @if (product.type === 'payment') {
        <div class="pin">
          <span class="fa fa-info-circle"></span> {{ product.title }}
        </div>
      }
    </div>
  }
</section>
<section class="accordions {{ scheme }}">
  @for (info of this.sortedProduct; track info) {
    <section class="accordion extra-info-accordion">
      @if (info.type === 'product') {
        <div>
          <header (click)="setAccordion(info.title)" class="dropdown button secondary tiny">
            <h1>{{ info.title }}</h1>
          </header>
          @if (displayAccordion == info.title) {
            <section class="expanded">
              <div class="body" style="max-width:100%; overflow:hidden; box-sizing:border-box; width:100%;">
                <div style="max-width:100%; overflow:hidden; box-sizing:border-box; width:100%;">
                  <div [innerHTML]="info.description"></div>
                  @if (info.file_type && info.file_type?.indexOf('image') > -1 && !info.thumbnails) {
                    <div>
              <img alt="{{ info.file_title }}" src="{{
                  '/product-extra-info-file/' + info.id + '/' + info.file_slug
                }}" />
                    </div>
                  }
                  @if (info.thumbnails.length === 0) {
                    <div>
                      @for (file of info.files; track file) {
                        <div class="download">
                          @if ( file.file_type &&
                            file.file_type?.indexOf('image') == -1
                            ) {
                            <div class="download">
                              <a [href]="file.downloadUrl" target="_blank" rel="noopener noreferrer">
                                <img src="/app/assets/img/download.png" />
                                {{
                                removeFileExtension(file.file_title_display || file.file_title || 'download')
                                }}
                              </a>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                  <div style="max-width:100%; overflow:hidden; box-sizing:border-box; width:100%; position:relative;">
                    @if (info.thumbnails.length > 0) {
                      <image-carousel [slug]="info.id" class="modal-carousel"
                        [items]="info.thumbnails"
                      style="display:block; max-width:100%; width:100%; box-sizing:border-box;"></image-carousel>
                    }
                  </div>
                </div>
              </div>
            </section>
          }
        </div>
      }
    </section>
  }
</section>